import type { CSSProperties } from 'react';
import './ImagePlaceholder.css';

export type ImagePlaceholderProps = {
  label: string;
  className?: string;
  style?: CSSProperties;
};

// Editorial placeholder: warm gradient + uppercase mono caption. Used wherever
// the proto reserves space for photography that Luxarabia will provide later.
export function ImagePlaceholder({ label, className, style }: ImagePlaceholderProps) {
  const classes = ['image-placeholder', className].filter(Boolean).join(' ');
  return (
    <div className={classes} style={style} aria-hidden="true">
      <span className="image-placeholder__label">{label}</span>
    </div>
  );
}
